




















































































































































































































































































































































































































































































































































































































































































































































import ViewModel from '@/views/Home';
export default ViewModel;
